export default function ($) {

    const $filters = $('.wc__archive-product-filters');

    if (!$filters.length) return;

    const setColumns = function (columns) {
        $('.wc__archive-product').toggleClass('is-cols-1', columns === 1);
        $('[data-action="archive_columns"]').each(function () {
            $(this).toggleClass('is-active', $(this).data('columns') === columns);
        });
    };

    try {
        setColumns(Number(localStorage.getItem('tds_archive_columns')) || 2);
    } catch (e) {}

    $(document).on('click', '[data-action="archive_columns"]', function () {
        const columns = $(this).data('columns');

        setColumns(columns);

        try {
            localStorage.setItem('tds_archive_columns', columns);
        } catch (e) {}
    });

    function getFilters() {
        const filters = {};

        $filters.find('[data-filter-taxonomy]').each(function () {
            const values = $(this).find('input:checked').map((i, input) => input.value).get();

            if (values.length) {
                filters[$(this).data('filter-taxonomy')] = values;
            }
        });

        return filters;
    }

    function updateUrl(filters) {
        const url = new URL(window.location.href);

        url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');

        [...url.searchParams.keys()].filter(key => key.startsWith('filter_') || ['kleur', 'maat'].includes(key)).forEach(key => url.searchParams.delete(key));

        Object.entries(filters).forEach(([key, values]) => url.searchParams.set($filters.find(`[data-filter-taxonomy="${key}"]`).data('url-key'), values.join(',')));

        history.replaceState(null, '', url.toString());
    }

    function fetchProducts() {
        const filters = getFilters();
        const $products = $('[data-filter="products"]');

        updateUrl(filters);
        $products.addClass('is-loading');

        $.post(ajaxURL, {
            action: 'fetch_filtered_products',
            nonce: ajaxNonce,
            filters: filters,
            facets: $filters.find('[data-filter-taxonomy]').map((i, el) => $(el).data('filter-taxonomy')).get(),
            orderby: $('select.orderby').val() || '',
            archive_taxonomy: $filters.data('archive-taxonomy') || '',
            archive_term: $filters.data('archive-term') || '',
            page: 1
        }, function (response) {
            if (!response.success) return;

            $products.removeClass('is-loading').html(response.data.products);
            $('[data-filter="pagination"]').replaceWith(response.data.pagination);
            $('[data-filter="result-count"]').html(response.data.result_count);

            $.each(response.data.facets || {}, function (taxonomy, counts) {
                $(`[data-filter-taxonomy="${taxonomy}"] label`).each(function () {
                    const count = counts[$(this).data('term-id')] || 0;

                    $(this).find('[data-filter="count"]').text(`(${count})`);
                    $(this).toggle(count > 0 || $(this).find('input').is(':checked'));
                });
            });
        });
    }

    $filters.on('change', 'input', fetchProducts);

    $filters.on('click', '[data-action="open__filters"]', function () {
        $(this).toggleClass('is-active').closest('.filters').toggleClass('is-active');
    });

    $(document).on('click', '[data-action="toggle_drawer_filters"]', function () {
        $filters.toggleClass('is-active');
        $('.wc__archive-product-filters-overlay').toggleClass('is-active');
    });

    $('form.woocommerce-ordering').on('submit', function (e) {
        const url = new URL(window.location.href);

        e.preventDefault();

        url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');
        url.searchParams.set('orderby', $(this).find('select.orderby').val());
        window.location.href = url.toString();
    });

    $(document).on('click', '[data-filter="pagination"] a', function (e) {
        const page = ($(this).attr('href').match(/\/page\/(\d+)/) || [])[1];
        const url = new URL(window.location.href);

        e.preventDefault();

        url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/') + (page > 1 ? `page/${page}/` : '');
        window.location.href = url.toString();
    });

}
